import React from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isFieldSurface } from '../../lib/inspection-surface';
import { TRIP_TYPE_LABEL, asTripType, isTripOffice } from '../../lib/trip-inspections';
import TripInspectionForm from './TripInspectionForm';
import TripPageChrome from './TripPageChrome';

/**
 * File a trip inspection. On the field surface it is always the driver's own;
 * in the office an office role may also key in a paper report for a chosen
 * driver, and any other role files as a driver (the API decides, api#855).
 *
 * `?type=pre_trip|post_trip` presets the kind (the Forms tab's two entries);
 * without it, or with any other value, the form asks.
 */
export default function TripInspectionNewPage() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const initialType = asTripType(params.get('type'));
  const onField = isFieldSurface(pathname);
  const mode = !onField && isTripOffice(user?.role) ? 'office' : 'driver';
  const base = onField ? '/field/trip-inspections' : '/trucking/trip-inspections';
  return (
    <TripPageChrome title={initialType ? `New ${TRIP_TYPE_LABEL[initialType]} Inspection` : 'New Trip Inspection'} eyebrow="Fleet safety" onBack={() => navigate(base)}>
      <TripInspectionForm key={initialType ?? 'ask'} mode={mode} initialType={initialType} onDone={(id) => navigate(`${base}/${id}`, { replace: true })} />
    </TripPageChrome>
  );
}
